const getExistingSubmissions = (submissionsData) => {
  return submissionsData.filter(({ id }) => {
    return !!id;
  });
};

export default getExistingSubmissions;
